document.addEventListener('DOMContentLoaded', function() {
    function handleCartClick(e) {
        if (window.innerWidth < 1024) { // 1024px is the default Tailwind lg breakpoint
            e.preventDefault();
        }
    }

    const cartLinks = document.querySelectorAll('.cart-wrapper > a');
    cartLinks.forEach(link => {
        link.addEventListener('click', handleCartClick);
    });
});
